
import _isNumber from 'lodash/isNumber'

import moment from 'moment-timezone'

import { parsePhoneNumberFromString } from 'libphonenumber-js'
import { formatSectionWaitTime } from '@/helpers/api'

import {
  ROUTE_URL_MODIFY,
  ROUTE_URL_CANCEL,
  ROUTE_URL_WAITLIST,
  ROUTE_NAME_MODIFY_WAITLIST,
  ROUTE_NAME_RESERVATIONS,
} from '@/router'
import {
  formatDateLongWithWeekday,
  browserTimeZoneDiffersFromMerchant,
} from '@/helpers/dates'
import { formatPriceString } from '@/helpers/prices'

import { constructNumberOfGuestsString } from '@/helpers/reservations'

import WiseImage from '@/components/WiseImage.jsx'

export default {
  name: 'Reservation',
  components: {
    WiseImage,
  },
  props: {
    merchant: Object,
    reservation: Object,
    confirm: Boolean,
    review: Boolean,
    waitTime: String,
    canceled: Boolean,
  },
  data() {
    return {
      ROUTE_URL_MODIFY,
      ROUTE_URL_CANCEL,
    }
  },
  computed: {
    currency() {
      return ((this.reservation || {}).inventoryItem || {}).currency
    },
    numberOfGuestsString() {
      return constructNumberOfGuestsString(
        this.numberOfGuests.value,
        false,
        this.merchant.guestAlternativeText
      )
    },
    merchantPhone() {
      if (!this.merchant.phone) {
        return
      }

      const parsedPhoneNumber = parsePhoneNumberFromString(this.merchant.phone)

      if (!parsedPhoneNumber) {
        return
      }

      return parsedPhoneNumber.formatInternational()
    },
    numberOfGuests: {
      get() {
        return this.reservation.numberOfGuests || {}
      },
    },
    timeZone() {
      return browserTimeZoneDiffersFromMerchant()
        ? ` ${moment().format('z')}`
        : undefined
    },
    date: {
      get() {
        return formatDateLongWithWeekday((this.reservation.day || {}).value)
      },
    },
    time: {
      get() {
        return (this.reservation.time || {}).label
      },
    },
    inventoryItemTitle: {
      get() {
        return (this.reservation.inventoryItem || {}).title
      },
    },
    modifyRoute: {
      get() {
        if (this.canceled) {
          return {
            name: ROUTE_NAME_RESERVATIONS,
          }
        }

        return this.reservation.waitlist
          ? {
              name: this.reservation.id
                ? ROUTE_NAME_MODIFY_WAITLIST
                : ROUTE_URL_WAITLIST,
            }
          : { name: ROUTE_URL_MODIFY }
      },
    },
    reservationPrice: {
      get() {
        return (this.reservation.inventoryItem || {}).price
      },
    },
    isFlatFee: {
      get() {
        return (this.reservation.inventoryItem || {}).isFlatFee
      },
    },
    subTotal: {
      get() {
        if (!this.reservationPrice) {
          return
        }

        if (this.reservationPrice.perTable || this.isFlatFee) {
          return this.reservationPrice.value
        }

        return this.reservationPrice.value * this.numberOfGuests.value
      },
    },
    subTotalFormatted: {
      get() {
        if (!_isNumber(this.subTotal)) {
          return
        }

        return formatPriceString(this.subTotal, undefined, this.currency)
      },
    },
    tax: {
      get() {
        if (!_isNumber(this.subTotal)) {
          return
        }

        return (this.reservationPrice.tax || 0) * this.subTotal
      },
    },
    taxFormatted: {
      get() {
        if (!_isNumber(this.subTotal)) {
          return
        }

        return formatPriceString(this.tax, undefined, this.currency)
      },
    },
    total: {
      get() {
        if (!_isNumber(this.subTotal) || !_isNumber(this.tax)) {
          return
        }

        return this.subTotal + this.tax
      },
    },
    totalFormatted: {
      get() {
        if (!_isNumber(this.total)) {
          return
        }

        return formatPriceString(this.total, undefined, this.currency)
      },
    },
    quoteFormatted: {
      get() {
        if (this.reservation.party) {
          const party = this.reservation.party
          const quote = { min: party.wait_min, max: party.wait_max }
          return formatSectionWaitTime(quote)
        }
      },
    },
  },
}
